import axios from 'axios'
import { passThroughAxios } from './passThrough.axios'

export default {
  getUnloadingLocations() {
    return axios.get('GetUnloadingLocations')
  },
  getEstablishments() {
    return axios.get('GetEstablishmentsForPurchaseOrder')
  },
  async getChangeOrders(page, includeNationWide, search) {
    const params = {
      page,
      includeNationWide,
      size: 15,
      search,
    }
    try {
      const response = await passThroughAxios.get('changeOrders', { params })
      return Promise.resolve(response.data.Results || [])
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async getChangeOrderByChangeOrderId(changeOrderId) {
    try {
      const response = await passThroughAxios.get(`changeOrder/${changeOrderId}`)
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async getChangeOrderByKomNumber(komNumber, komYear, quoteId) {
    try {
      const response = await passThroughAxios.get(`changeOrder/byKomNumber/${komNumber}`, {
        params: {
          komYear: komYear,
          quoteId: quoteId,
        },
      })
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async createChangeOrder(changeOrder) {
    try {
      const response = await passThroughAxios.post('changeOrders', changeOrder)
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async updateChangeOrder(changeOrder) {
    try {
      const response = await passThroughAxios.put('changeOrders', changeOrder)
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async previewChangeOrder(changeOrderId) {
    try {
      const response = await passThroughAxios.post(`previewChangeOrder/${changeOrderId}`)
      return response.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async submitChangeOrder(changeOrderId) {
    try {
      const response = await passThroughAxios.post(`submitChangeOrder/${changeOrderId}`)
      return response.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async submitChangeOrderSigning(changeOrderParams) {
    const {
      changeOrderId,
      sendEmailToCustomer,
      sendCopyToEmployee,
      customerMessage = '',
      sendSigning = false,
      digitalSigningParams = null,
    } = changeOrderParams

    const result = await passThroughAxios.post(`previewChangeOrder/${changeOrderId}`)

    // email / digital signing via C# only when preview succeeded
    if (result.data?.GenericResult?.Status === 'OK') {
      await axios.post(
        `SendChangeOrderEmailOrSigning/${changeOrderId}` +
          `?sendEmailToCustomer=${sendEmailToCustomer}` +
          `&sendEmailToEmployee=${sendCopyToEmployee}` +
          `&sendSigning=${sendSigning}` +
          `&customerMessage=${encodeURIComponent(customerMessage)}`,
        digitalSigningParams,
        { headers: { 'Content-Type': 'application/json' } }
      )
    }

    return result.data
  },
  async verifyChangeOrder(optionCodes, modelNumber) {
    try {
      const response = await passThroughAxios.post(
        `changeOrder/verifyOptions?modelNumber=${modelNumber}`,
        optionCodes
      )
      return response.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async deleteChangeOrder(changeOrderId) {
    try {
      return await passThroughAxios.delete(`changeOrder/${changeOrderId}`)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async getChangeOrderExcelResult(changeOrderId) {
    try {
      const response = await passThroughAxios.get(`changeOrder/${changeOrderId}/excelResult`)
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async changeSigningStatus(changeOrderId, newStatus) {
    try {
      let response = await passThroughAxios.put(
        `changeOrder/${changeOrderId}/changesigningstatus?status=${newStatus}`
      )
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async getChangeOrderEmailBody(changeOrderId) {
    try {
      const response = await passThroughAxios.get(`changeOrder/${changeOrderId}/email/body`)
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async getChangeOrderEmailInfoForDigitalSigning(changeOrderId) {
    try {
      const response = await passThroughAxios.get(
        `changeOrder/${changeOrderId}/email/info/digital-signing`
      )
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
}
